import * as React from "react";

const SvgRight = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.293 4.293a1 1 0 0 1 1.32-.083l.094.083 7 7a1 1 0 0 1 .083 1.32l-.083.094-7 7a1 1 0 0 1-1.497-1.32l.083-.094L15.585 12 9.293 5.707a1 1 0 0 1-.083-1.32l.083-.094Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

export default SvgRight;
